import { ProtectedRoute } from '@shared/components/ProtectedRoute'
import { BrowserRouter, Route, Routes } from 'react-router'
import { Home } from './home'
import { Login } from './login'

export const RoutingProvider = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
